import ManualSorting from '@features/ManualSorting/ui/ManualSorting';

export default function ManualSortingPage() {
  return <ManualSorting />;
}
